// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__g6oY3","addWidgetButton":"Header_addWidgetButton__3ILFp","dashboardTabs":"Header_dashboardTabs__2ITYM","active":"Header_active__LKnyG"};